import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const buttonVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.5,
        delay: 1.2,
      },
    },
    hover: {
      scale: 1.05,
      transition: { duration: 0.2 },
    },
  };

  return (
    <div className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Very subtle gradient transition */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-gray-900/10 to-transparent pointer-events-none z-10" />
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black">
        {/* Floating particles - reduced for performance */}
        {[...Array(8)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full pointer-events-none"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 2 + 1}px`,
              height: `${Math.random() * 2 + 1}px`,
            }}
            animate={{
              y: [0, -15, 0],
              opacity: [0.3, 0.7, 0.3],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              delay: i * 0.5,
              ease: "easeInOut",
            }}
          >
            <div className="w-full h-full bg-cyan-400/50 rounded-full" />
          </motion.div>
        ))}

        {/* Neural network lines - reduced for performance */}
        {[...Array(4)].map((_, i) => (
          <motion.div
            key={`line-${i}`}
            className="absolute h-px bg-gradient-to-r from-transparent via-cyan-400/15 to-transparent pointer-events-none"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 100 + 60}px`,
              transform: `rotate(${Math.random() * 360}deg)`,
            }}
            animate={{
              opacity: [0, 0.3, 0],
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              delay: i * 2,
              ease: "easeInOut",
            }}
          />
        ))}
        

      </div>

      {/* Content */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="relative z-10 text-center px-4 max-w-6xl mx-auto"
      >
        {/* Main Headline */}
        <motion.h1
          variants={itemVariants}
          className="hero-title text-6xl md:text-8xl lg:text-9xl font-clash font-bold mb-8 leading-tight"
        >
          <span className="gradient-text">I Build Products</span>
          <br />
          <span className="text-white">that Feel Alive.</span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          variants={itemVariants}
          className="hero-subtitle text-xl md:text-2xl lg:text-3xl text-gray-300 mb-16 font-inter font-light max-w-4xl mx-auto leading-relaxed"
        >
          Web, Apps & SaaS — crafted with precision and purpose.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          variants={itemVariants}
          className="flex flex-col sm:flex-row gap-6 justify-center items-center"
        >
          <motion.button
            variants={buttonVariants}
            whileHover="hover"
            className="btn-primary text-lg px-8 py-4"
            data-cursor="pointer"
            onClick={() => document.getElementById('showcase').scrollIntoView({ behavior: 'smooth' })}
          >
            See My Work
          </motion.button>
          
          <motion.button
            variants={buttonVariants}
            whileHover="hover"
            className="btn-secondary text-lg px-8 py-4"
            data-cursor="pointer"
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
          >
            Hire Me
          </motion.button>
        </motion.div>

      </motion.div>
    </div>
  );
};

export default Hero;
